var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { communicationChartChannelKey } from '@web/components/CommunicationNetworkGraph/components/communicationChartI18n';
import { COMMUNICATION_CHART_CHANNELS } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
import { cx } from '@web/utility';
import { useTranslation } from 'react-i18next';
export var CommunicationChartLineVisibilityToggle = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var t = useTranslation().t;
    return (_jsx("div", __assign({ className: "w-fit shrink-0" }, { children: _jsx("div", __assign({ className: "inline-flex w-fit flex-wrap gap-1 rounded-lg border border-slate-200 bg-white/95 p-1 shadow-sm backdrop-blur-sm", role: "radiogroup", "aria-label": t('app.dashboard.communicationChart.lineVisibility.title') }, { children: COMMUNICATION_CHART_CHANNELS.map(function (option) {
                var isSelected = value === option;
                return (_jsx("button", __assign({ type: "button", role: "radio", "aria-checked": isSelected, className: cx('rounded-md border px-4 py-2 text-sm font-semibold transition-colors', isSelected
                        ? 'border-slate-300 bg-slate-100 text-indigo-600 shadow-sm hover:border-indigo-500 hover:text-indigo-700'
                        : 'border-transparent text-slate-700 hover:bg-slate-50 hover:text-indigo-600'), onClick: function () { return onChange(option); } }, { children: t(communicationChartChannelKey(option)) }), option));
            }) })) })));
};
